import { render } from "./AddBalancePage.vue?vue&type=template&id=52d85df9&scoped=true"
import script from "./AddBalancePage.vue?vue&type=script&lang=js"
export * from "./AddBalancePage.vue?vue&type=script&lang=js"

import "./AddBalancePage.vue?vue&type=style&index=0&id=52d85df9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52d85df9"]])

export default __exports__